import ReactGA from 'react-ga';

export function getUrl() {

  let proto    = 'http';
  let hostname = 'localhost';
  let port     = '8008';

  if (process.env.NODE_ENV === 'production') {
    proto    = 'https'; // future https
    hostname = 'www.flashmusic.rocks';
    port     = '443';
  }

  return proto + '://' + hostname + ':' + port + '/'
}

export function requestNewGame(props, callback) {
  if (props.gameType === 'notes') {
    newNotecardGame(props, callback);
  }
  if (props.gameType === 'frets') {
    newFretboardGame(props, callback);
  }
}

async function newNotecardGame(props, callback) {
  ReactGA.pageview('apiClient::newNotecardGame');
  let url = getUrl() + 'api/game/new/notecard/';
  url += props.clef + '/';
  url += props.kee  + '/';
  url += props.questionCount;
  fetch(url).then(response => response.json()).then(game => {
    let url = getUrl() + 'api/game/question/' + game.id + '/1';
    fetch(url).then(r => r.json()).then(question => {callback(game, question);});
  });
};

async function newFretboardGame(props, callback) {
  ReactGA.pageview('apiClient::newFretboardGame');
  let url = getUrl() + 'api/game/new/fretboard/' + props.questionCount;
  fetch(url).then(response => response.json()).then(game => {
    let url = getUrl() + 'api/game/question/' + game.id + '/1';
    fetch(url).then(r => r.json()).then(question => {callback(game, question);});
  })
};

export async function sendGuess(props) {
  ReactGA.pageview('apiClient::sendGuess');
  let url = getUrl() + 'api/game/guess/' + props.gameId + '/' + props.sequenceNumber + '/' + props.guess;
  fetch(url).then(response => response.json()).then(question => { props.processNextQuestion(question); });
};

export async function gameOver(props) {
  ReactGA.pageview('apiClient::gameOver:' + props.game.uuid);
  let url = getUrl() + 'api/game/over/' + props.game.uuid;
  fetch(url);
};
